import { WIDGET_BREAKPOINTS } from '../../../utils/common';

export const getNumOfLabels = (width: number, start = 5, step = 5) => {
  return Object.values(WIDGET_BREAKPOINTS).reduce(
    (acc, bp) => (width > bp ? acc + step : acc),
    start,
  );
};
